import React from 'react';
import { usePanelView } from '../../PanelView';

interface AppViewHeaderProps {
  children: ((activePanel: string) => React.ReactNode) | React.ReactNode;
}

export const AppViewHeader = ({ children }: AppViewHeaderProps) => {
  const { activePanel } = usePanelView();

  return (
    <div className="flex items-center justify-between gap-4 bg-card-dark border-2 border-background-dark px-3 py-2 h-12 rounded-t">
      {typeof children === 'function' ? children(activePanel) : children}
    </div>
  );
};
